import { AnyAction } from 'redux';
import { pclTypes } from 'redux/actions/pclAction';

interface NoScanReason {
  label: string;
  value: string;
}

interface PclState {
  noScanReasons: NoScanReason[];
}

const defaultState: PclState = {
  noScanReasons: [],
};

const pclReducer = (state = defaultState, action: AnyAction) => {
  const { noScanReasons } = action;

  switch (action.type) {
    case pclTypes.GET_NO_SCAN_REASONS_SUCCESS:
      return {
        ...state,
        noScanReasons,
      };
    default:
      return state;
  }
};

export default pclReducer;
